import {
  Clapperboard,
  Command,
  ShoppingCart,
  Users,
  Wrench,
  Bell,
  FileText,
  UserCheck,
  BarChart3,
  Store,
  ShieldCheck,
  CreditCard,
  CalendarClock,
} from "lucide-react";

import { NavProjects } from "@/components/nav-projects";
import { NavUser } from "@/components/nav-user";
import { TeamSwitcher } from "@/components/team-switcher";
import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader, SidebarRail } from "@/components/ui/sidebar";

const data = {
  projects: [
    {
      name: "Dashboard",
      url: "/partner/dashboard",
      icon: Command,
    },
    {
      name: "Analytics",
      url: "/partner/analytics",
      icon: BarChart3,
    },
    {
      name: "Equipments Items",
      url: "/partner/equipments",
      icon: Clapperboard,
    },
    {
      name: "Maintenance Overview",
      url: "/partner/maintenance_overview",
      icon: Wrench,
    },
    {
      name: "Orders",
      url: "/partner/orders",
      icon: ShoppingCart,
    },
    {
      name: "Schedule",
      url: "/partner/schedules",
      icon: CalendarClock,
    },
    {
      name: "Invoices",
      url: "/partner/invoices",
      icon: FileText,
    },
    {
      name: "Notifications",
      url: "/partner/notifications",
      icon: Bell,
    },
    {
      name: "Customers",
      url: "/partner/customers",
      icon: Users,
    },
    {
      name: "Attendants",
      url: "/partner/attendants",
      icon: UserCheck,
    },
    {
      name: "Stores",
      url: "/partner/settings/stores",
      icon: Store,
    },
    {
      name: "Payment Methods",
      url: "/partner/payment_methods",
      icon: CreditCard,
    },
    {
      name: "Verification",
      url: "/partner/onboarding/status",
      icon: ShieldCheck,
    },
  ],
};

export function AppSidebar({ user, ...props }) {
  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <TeamSwitcher />
      </SidebarHeader>
      <SidebarContent>
        {/*<NavMain items={data.navMain} />*/}
        <NavProjects projects={data.projects} />
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={user} />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
